import { InputText } from '../../../Form/InputText';
import { Select } from '../../../Form/Select';
import { InnerTabSpace } from '../../../Layout/InnerLayout/InnerTabSpace';
import { TableBody } from '../../../Table/TableBody';
import { TableTrFormLabel } from '../../../Table/TableTr/TableTrFromLabel';

import {
  BorrowingPeriodId,
  borrowingPeriodList,
  ScholarshipStatusId,
  scholarshipStatusList,
  ScholarshipTypeId,
  scholarshipTypeList,
} from './scholarship';

import type { InvalidErrors } from './createInvalidErrors';
import type { SelectAttribute } from '../../../../types/SelectAttribute';
import type { FC, ChangeEventHandler } from 'react';

type Props = {
  schoolTypeAttributes: SelectAttribute[];
  graduationYearAttributes: SelectAttribute[];
  schoolName: string;
  schoolTypeId: number;
  graduationYear: number;
  scholarshipStatus: ScholarshipStatusId;
  scholarshipType: ScholarshipTypeId;
  borrowingPeriod: BorrowingPeriodId;
  onChangeSchoolName: ChangeEventHandler<HTMLInputElement>;
  onChangeSchoolType: ChangeEventHandler<HTMLSelectElement>;
  onChangeGraduationYear: ChangeEventHandler<HTMLSelectElement>;
  onChangeScholarshipStatus: ChangeEventHandler<HTMLSelectElement>;
  onChangeScholarshipType: ChangeEventHandler<HTMLSelectElement>;
  onChangeBorrowingPeriod: ChangeEventHandler<HTMLSelectElement>;
  invalidErrors?: InvalidErrors;
};

const scholarshipStatusAttributes = scholarshipStatusList.map(
  (value, index) => ({
    key: index,
    value: String(value.id),
    label: value.label,
  }),
);

const scholarshipTypeAttributes = scholarshipTypeList.map((value, index) => ({
  key: index,
  value: String(value.id),
  label: value.label,
}));

const borrowingPeriodAttributes = borrowingPeriodList.map((value, index) => ({
  key: index,
  value: String(value.id),
  label: value.label,
}));

// eslint-disable-next-line max-lines-per-function
export const AcademicBackgroundTabPanel: FC<Props> = ({
  schoolTypeAttributes,
  graduationYearAttributes,
  schoolName,
  schoolTypeId,
  graduationYear,
  scholarshipStatus,
  scholarshipType,
  borrowingPeriod,
  onChangeSchoolName,
  onChangeSchoolType,
  onChangeGraduationYear,
  onChangeScholarshipStatus,
  onChangeScholarshipType,
  onChangeBorrowingPeriod,
  invalidErrors,
}) => (
  <InnerTabSpace>
    <TableBody>
      <TableTrFormLabel
        id="schoolName"
        required={false}
        errorMessage={
          invalidErrors?.schoolNameError?.reason
            ? invalidErrors?.schoolNameError?.reason
            : ''
        }
        title="卒業学校/卒業予定学校"
      >
        <InputText
          name="schoolName"
          id="schoolName"
          type="text"
          width="default"
          placeholder=""
          defaultValue={schoolName}
          onChange={onChangeSchoolName}
        />
      </TableTrFormLabel>
      <TableTrFormLabel
        id="schoolType"
        required={false}
        errorMessage={
          invalidErrors?.schoolTypeIdError?.reason
            ? invalidErrors?.schoolTypeIdError?.reason
            : ''
        }
        title="学校種別"
      >
        <Select
          id="schoolType"
          width="default"
          attributes={schoolTypeAttributes}
          defaultValue={String(schoolTypeId)}
          onChange={onChangeSchoolType}
        />
      </TableTrFormLabel>
      <TableTrFormLabel
        id="graduationYear"
        required={false}
        errorMessage={
          invalidErrors?.graduationYearError?.reason
            ? invalidErrors?.graduationYearError?.reason
            : ''
        }
        title="卒業年"
      >
        <Select
          id="graduationYear"
          width="default"
          attributes={graduationYearAttributes}
          defaultValue={String(graduationYear)}
          onChange={onChangeGraduationYear}
        />
      </TableTrFormLabel>
      <TableTrFormLabel
        id="scholarshipStatus"
        required={false}
        errorMessage={
          invalidErrors?.scholarshipStatusError?.reason
            ? invalidErrors?.scholarshipStatusError?.reason
            : ''
        }
        title="奨学金借入状況"
      >
        <Select
          id="scholarshipStatus"
          width="default"
          attributes={scholarshipStatusAttributes}
          defaultValue={String(scholarshipStatus)}
          onChange={onChangeScholarshipStatus}
        />
      </TableTrFormLabel>
      <TableTrFormLabel
        id="scholarshipType"
        required={false}
        errorMessage={
          invalidErrors?.scholarshipTypeError?.reason
            ? invalidErrors?.scholarshipTypeError?.reason
            : ''
        }
        title="奨学金種別"
      >
        <Select
          id="scholarshipType"
          width="default"
          attributes={scholarshipTypeAttributes}
          defaultValue={String(scholarshipType)}
          onChange={onChangeScholarshipType}
        />
      </TableTrFormLabel>
      <TableTrFormLabel
        id="borrowingPeriod"
        required={false}
        errorMessage={
          invalidErrors?.borrowingPeriodError?.reason
            ? invalidErrors?.borrowingPeriodError?.reason
            : ''
        }
        title="奨学金借入（予定）年数"
      >
        <Select
          id="borrowingPeriod"
          width="default"
          attributes={borrowingPeriodAttributes}
          defaultValue={String(borrowingPeriod)}
          onChange={onChangeBorrowingPeriod}
        />
      </TableTrFormLabel>
    </TableBody>
  </InnerTabSpace>
);
